import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=34fc41f3&scoped=true"
import script from "./phone.vue?vue&type=script&lang=ts"
export * from "./phone.vue?vue&type=script&lang=ts"
import style0 from "./phone.vue?vue&type=style&index=0&id=34fc41f3&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc41f3",
  null
  
)

export default component.exports